import { render, staticRenderFns } from "./WaveComponent.vue?vue&type=template&id=52812e5a&scoped=true"
import script from "./WaveComponent.vue?vue&type=script&lang=js"
export * from "./WaveComponent.vue?vue&type=script&lang=js"
import style0 from "./WaveComponent.vue?vue&type=style&index=0&id=52812e5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52812e5a",
  null
  
)

export default component.exports